export const ListAndDetailSamplesAdditionalActionsPageInfo = () => {
    return (
        <>
            You can add additional actions to the toolbar, you can:
            <ul>
                <li>Put these before the new button or delete button (use position - if position is not set it will go after the delete button).</li>
                <li>Say wether they are always available, available for one 1 item checked or for multiple checks.</li>
                <li>Change the colour of the icon.</li>
                <li>You can also use avatars.</li>
                <li>You can also add spacing between certain action icons.</li>
            </ul>
        </>
    )
}
